import { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { FormControlLabel, Checkbox } from '@mui/material';
import EnumSelector from './EnumSelector';
import { getMinMax } from '../../../utils/collections';
import { percentileColor } from '../../util/data-table';
import { PredictionsChip } from '../../util/DataTableCells';

const Selector = ({
  entities,
  onChange,

  equipmentTypes,
}) => {
  const equipment = entities;
  const [predictionsOnly, setPredictionsOnly] = useState(true);

  const [typePredictions, ets] = useMemo(() => {
    const tp = getMinMax(
      equipment.map((p) => p.data?.['auto_tagger.equip_type_preds'] ?? {}),
      true
    );
    let eTypes = Object.values(equipmentTypes);
    if (predictionsOnly)
      eTypes = eTypes.filter((et) => Object.prototype.hasOwnProperty.call(tp, et.tagName));
    return [tp, Object.fromEntries(eTypes.map((et) => [et.id, et]))];
  }, [equipment, equipmentTypes, predictionsOnly]);
  return (
    <>
      <EnumSelector
        entities={equipment}
        onChange={onChange}
        name="Equipment Type"
        enums={ets}
        extractEnumId={(e) => e.equipmentTypeId}
        enumId={(et) => et.id}
        enumLabel={(et) => et.nameAbbr}
        renderBadge={(et) => (
          <PredictionsChip
            color={percentileColor(typePredictions[et.tagName]?.max)}
            predictions={typePredictions[et.tagName]}
          />
        )}
        sortFn={(etA, etB) => {
          const predA = typePredictions[etA.tagName];
          const predB = typePredictions[etB.tagName];
          if (predA) {
            if (predB) return predB.max - predA.max;
            return -1;
          }
          if (predB) return 1;
          return etB.tagName.localeCompare(etA.tagName);
        }}
      />
      <FormControlLabel
        label="Predictions Only"
        control={
          <Checkbox
            checked={predictionsOnly}
            onChange={(event) => setPredictionsOnly(event.target.checked)}
          />
        }
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  equipmentTypes: state.entities.equipTypes.byId,
});

const EquipmentTypeSelector = connect(mapStateToProps)(Selector);

EquipmentTypeSelector.displayName = 'Equipment Type Selector';

export default EquipmentTypeSelector;
